(function () {
  var LIGHT_THRESHOLD = 230;
  var SAMPLE_SIZE = 6;
  var BRIGHTNESS = 0.965;

  function isLight(r, g, b) {
    return r > LIGHT_THRESHOLD && g > LIGHT_THRESHOLD && b > LIGHT_THRESHOLD;
  }

  function sampleViaCors(src, callback) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function() {
      try {
        var canvas = document.createElement('canvas');
        canvas.width = SAMPLE_SIZE;
        canvas.height = SAMPLE_SIZE;
        var ctx = canvas.getContext('2d');
        var w = probe.naturalWidth;
        var h = probe.naturalHeight;
        var patches = [[0,0],[w-SAMPLE_SIZE,0],[0,h-SAMPLE_SIZE],[w-SAMPLE_SIZE,h-SAMPLE_SIZE]];
        var lightCount = 0;
        var sumR = 0, sumG = 0, sumB = 0;
        for (var i = 0; i < patches.length; i++) {
          ctx.drawImage(probe, patches[i][0], patches[i][1], SAMPLE_SIZE, SAMPLE_SIZE, 0, 0, SAMPLE_SIZE, SAMPLE_SIZE);
          var d = ctx.getImageData(0, 0, 1, 1).data;
          sumR += d[0]; sumG += d[1]; sumB += d[2];
          if (isLight(d[0], d[1], d[2])) lightCount++;
        }
        var avg = [Math.round(sumR/4), Math.round(sumG/4), Math.round(sumB/4)];
        callback(lightCount >= 3, avg);
      } catch(e) { callback(false, null); }
    };
    probe.onerror = function() { callback(false, null); };
    probe.src = src.split('&width=')[0] + '&width=100';
  }

  function rawColor(rgb) {
    return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
  }

  function markDone(img) {
    img.dataset.bgDone = '1';
    document.dispatchEvent(new CustomEvent('jb:img-checked'));
  }

  function checkCollectionImg(img) {
    if (img.dataset.bgChecked) return;
    img.dataset.bgChecked = '1';
    sampleViaCors(img.currentSrc || img.src, function(light) {
      if (!light) {
        img.style.objectFit = 'cover';
        img.style.padding = '0';
        img.style.filter = 'none';
      }
      markDone(img);
    });
  }

  function checkProductImg(img) {
    if (img.dataset.bgChecked) return;
    img.dataset.bgChecked = '1';
    var slide = img.closest('.splide__slide');
    var isFirst = slide && !slide.previousElementSibling;
    sampleViaCors(img.currentSrc || img.src, function(light, avg) {
      if (light) {
        img.style.filter = 'brightness(' + BRIGHTNESS + ')';
        if (isFirst) {
          img.style.objectFit = 'contain';
          // Raw color: the brightness filter darkens the background-color too,
          // so image bg and padding bg end up identical after filtering.
          img.style.backgroundColor = avg ? rawColor(avg) : '#ffffff';
        }
      }
      markDone(img);
    });
  }

  function processAll() {
    document.querySelectorAll('.card-product__media-inner .product-first-image img').forEach(function(img) {
      if (img.complete && img.naturalWidth > 0) { checkCollectionImg(img); }
      else { img.addEventListener('load', function() { checkCollectionImg(this); }); }
    });

    document.querySelectorAll('.product-media-container img').forEach(function(img) {
      if (img.complete && img.naturalWidth > 0) { checkProductImg(img); }
      else { img.addEventListener('load', function() { checkProductImg(this); }); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  var observer = new MutationObserver(processAll);
  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
